
import Dashboard from "./components/index";

const routes = {
    path: "",
    children: [
        { path: "", element: <Dashboard /> },
    ]
};

export default routes;
